import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Fale from "../components/fale"



export default function Contact({data}) {
	return (
			<Layout>
			<h1>Contact {data.site.siteMetadata.title}</h1>
			<p>
			We're the only site running on your computer dedicated to showing the
			best photos and videos of pandas eating lots of food.
			</p>
			<Fale></Fale>
			</Layout>
	       )
}

export const query = graphql`
query{
	site{
		siteMetadata{
			title
		}
	}
}
`
